import ApplicationController from '../application_controller.js'
import { isNumber, parseString } from '../../commons.js'
import axios from 'axios'
import State from './state.js'

export default class IndexController extends ApplicationController {

  static targets = [
    "batchUpdateBlock", "batchUpdateHourlyRate", "batchUpdateFormValidateButton"
  ]

  connect() {
    State.editor_opened = false
  }

  // Ouvre le formulaire de saisie d'une task ou charge
  new_form(e) {
    e.preventDefault()

    if (!State.editor_opened) {
      axios.get(e.target.getAttribute('href')).then(response => {
        e.target.closest('fieldset').querySelector('div.table .thead').insertAdjacentHTML('afterend', response.data)
        State.editor_opened = true
      })
    }
  }

  // Toggle block de mise à jour d'un taux
  toggleBatchUpdateBlock(e) {
    e.preventDefault()
    this.batchUpdateBlockTarget.style.display = this.batchUpdateBlockTarget.style.display === "none" ? "block" : "none"
    this.batchUpdateHourlyRateTarget.value = null
    this.batchUpdateFormValidateButtonTarget.disabled = true
  }

  // Peut-on valider le form de modification du taux ?
  checkBatchUpdateFormCanValidate(e) {
    this.batchUpdateFormValidateButtonTarget.disabled = isNaN(parseString(e.target.value))
  }

}